import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" className="w-7 h-7" fill="white">
    <path d="M16.002 0C7.165 0 0 7.163 0 16c0 2.822.736 5.564 2.137 7.99L.073 32l8.214-2.148A15.93 15.93 0 0 0 16.002 32C24.838 32 32 24.837 32 16S24.838 0 16.002 0zm0 29.394a13.36 13.36 0 0 1-6.813-1.866l-.489-.29-5.065 1.326 1.352-4.932-.319-.506A13.306 13.306 0 0 1 2.607 16c0-7.39 6.014-13.394 13.395-13.394 7.38 0 13.393 6.004 13.393 13.394 0 7.391-6.013 13.394-13.393 13.394zm7.338-10.02c-.402-.2-2.378-1.173-2.746-1.307-.369-.134-.637-.2-.905.201-.268.4-1.04 1.307-1.274 1.575-.235.268-.47.301-.871.1-.402-.2-1.696-.625-3.23-1.993-1.194-1.065-2-2.38-2.235-2.782-.234-.4-.025-.617.176-.816.181-.18.402-.469.603-.703.2-.234.267-.4.4-.669.134-.268.067-.502-.033-.703-.1-.2-.905-2.18-1.24-2.986-.326-.783-.658-.678-.905-.69-.234-.011-.502-.014-.77-.014-.268 0-.703.1-1.072.502-.368.4-1.407 1.374-1.407 3.352 0 1.979 1.44 3.89 1.64 4.158.201.268 2.834 4.326 6.867 6.066.96.414 1.709.661 2.293.847.964.306 1.84.263 2.533.16.773-.116 2.378-.972 2.714-1.91.335-.939.335-1.744.234-1.911-.1-.168-.368-.268-.77-.469z"/>
  </svg>
);

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/56987654321?text=Hola,%20me%20gustaría%20solicitar%20información%20sobre%20sus%20servicios%20eléctricos.', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`
          w-14 h-14 rounded-full 
          glass-liquid-dark-heavy backdrop-blur-xl
          border border-white/20
          flex items-center justify-center
          text-white hover:text-primary
          shadow-liquid-lg hover:shadow-liquid-xl
          transition-all duration-300
          hover:scale-110 hover:border-primary/50
          ${showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
        `}
        aria-label="Volver al inicio"
      >
        <ArrowUp className="w-6 h-6" />
      </button>

      {/* WhatsApp Button */}
      <button
        onClick={openWhatsApp}
        className="
          w-14 h-14 rounded-full 
          bg-[#25D366] hover:bg-[#20BD5A]
          flex items-center justify-center
          text-white
          shadow-lg hover:shadow-xl
          transition-all duration-300
          hover:scale-110
        "
        aria-label="Contactar por WhatsApp"
        style={{
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)'
        }}
      >
        <WhatsAppIcon />
      </button>
    </div>
  );
};

export default FloatingButtons;
